import BaseLevelScene from './BaseLevelScene';

export default class MonumentalChurchScene extends BaseLevelScene {
  tileWidth: integer = 32;
  tileHeight: integer = 32;
  name: string;
  tileMapName: string;
  tileMapPath: string;
  zoom: number;
  constructor(name: string, tilemapName:string, tileMapPath: string,
    playerScale: number = 0.8, zoom: number = 1.2) {
    super(name);
    this.name = name;
    this.tileMapName = tilemapName;
    this.tileMapPath = tileMapPath;
    this.playerScale = playerScale;
    this.zoom = zoom;
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the PNG file
    this.load.image('fantasy_interior_tiles', 'assets/sourceImages/Fantasy RPG Interior Pack (32x32 grid).png');
    this.load.image('music_tiles', 'assets/sourceImages/Expansion_Music.png');
    this.load.image('catacomb', 'assets/sourceImages/mainlevbuild.png');

    // load the JSON map
    this.load.tilemapTiledJSON(
      this.tileMapName,
      this.tileMapPath,
    );
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image
    // this.add.image(0, 0, 'catacomb');

    // create the Tilemap
    this.map = this.make.tilemap({ key: this.tileMapName });

    // add the tileset image we are using
    const interiorTileset = this.map.addTilesetImage('fantasyInterior', 'fantasy_interior_tiles');
    const musicTileset = this.map.addTilesetImage('music', 'music_tiles');
    const catacombTileset = this.map.addTilesetImage('catacomb', 'catacomb');

    const allLayers = [interiorTileset, musicTileset, catacombTileset];

    // create the layers we want in the right order
    const floor = this.map.createLayer('Base', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(floor);

    const textures = this.map.createLayer('Textures', allLayers);
    this.matter.world.convertTilemapLayer(textures);

    const furniture = this.map.createLayer('Furniture', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    const decorations = this.map.createLayer('Decorations', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(decorations);


    // create base level
    this.createBaseLevel(this.playerScale, this.zoom);
  }
}
